import { PanayaRoute } from '@frontend-site/shared/router-store';
import { MenuStates } from '@frontend-site/main-header/domain';
import { ReleaseDetailsResolver, ReleaseNameResolver } from '@frontend-site/shared/core';
import { LoopbackComponent } from '@frontend-site/shared/hybrid';

export const RDX_ROUTES: PanayaRoute = Object.freeze<PanayaRoute>({
    path: 'releaseDynamix',
    data: { navState: 'rdx' },
    children: [
        {
            path: ':companyId',
            data: { navState: 'rdx.company' },
            children: [
                {
                    path: 'contextSelector',
                    data: { navState: 'rdx.company.navigator' },
                    children: [
                        {
                            path: 'chart',
                            data: { navState: 'rdx.company.navigator.chart', menuState: MenuStates.ALL_PROJECTS, rememberMe: true },
                            component: LoopbackComponent
                        },
                        {
                            path: 'list',
                            data: { navState: 'rdx.company.navigator.list' },
                            component: LoopbackComponent
                        }
                    ]
                },
                {
                    path: 'portfolio',
                    data: { navState: 'rdx.company.portfolio', menuState: MenuStates.ALL_PROJECTS },
                    children: [
                        { path: '', redirectTo: 'requirements/list', pathMatch: 'full' },
                        {
                            path: 'requirements',
                            data: { navState: 'rdx.company.portfolio.requirements' },
                            children: [
                                { path: '', redirectTo: 'list', pathMatch: 'full' },
                                {
                                    path: 'list',
                                    data: { navState: 'rdx.company.portfolio.requirements.list' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'board',
                                    data: { navState: 'rdx.company.portfolio.requirements.board', menuState: MenuStates.ALL_PROJECTS },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'requirementDetails/:requirementId',
                                    data: {
                                        navState: 'rdx.company.portfolio.requirements.requirementDetails',
                                        navMenuHighlight: {
                                            keepPreviousHighlightState: true
                                        }
                                    },
                                    component: LoopbackComponent
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'release/:id',
                    data: { navState: 'rdx.company.release', menuState: MenuStates.RELEASE },
                    resolve: { releaseName: ReleaseNameResolver },
                    children: [
                        {
                            path: 'risk',
                            data: { navState: 'rdx.company.release.risk', rememberMe: true },
                            resolve: { releaseDetails: ReleaseDetailsResolver },
                            component: LoopbackComponent
                        },
                        {
                            path: 'progress',
                            data: { navState: 'rdx.company.release.progress' },
                            children: [
                                { path: '', redirectTo: 'overview', pathMatch: 'full' },
                                {
                                    path: 'overview',
                                    data: { navState: 'rdx.company.release.progress.overview', rememberMe: true },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'requirementCoverage',
                                    data: { navState: 'rdx.company.release.progress.requirementCoverage' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'workflowsApprovalStatus',
                                    data: { navState: 'rdx.company.release.progress.workflowsApprovalStatus' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'developmentProgress',
                                    data: { navState: 'rdx.company.release.progress.developmentProgress' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'overlappingRequirements',
                                    data: { navState: 'rdx.company.release.progress.overlappingRequirements' },
                                    component: LoopbackComponent
                                }
                            ]
                        },
                        {
                            path: 'progressdefectsStatus',
                            data: { navState: 'rdx.company.release.progress.defectsStatus' },
                            component: LoopbackComponent
                        },
                        {
                            path: 'general',
                            data: { navState: 'rdx.company.release.general', rememberMe: true },
                            component: LoopbackComponent
                        },
                        {
                            path: 'requirements',
                            data: { navState: 'rdx.company.release.requirements' },
                            children: [
                                {
                                    path: 'board',
                                    data: { navState: 'rdx.company.release.requirements.board' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'list',
                                    data: { navState: 'rdx.company.release.requirements.list', rememberMe: true },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'entityNotFoundError',
                                    data: { navState: 'rdx.company.release.requirements.entityNotFoundError' },
                                    component: LoopbackComponent
                                },
                                {
                                    path: 'requirementDetails/:requirementId',
                                    data: { navState: 'rdx.company.release.requirements.requirementDetails' },
                                    component: LoopbackComponent
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
});
